import { useState } from "react";

/**
 * Local editable state that starts from `source` and starts over whenever `sourceKey` changes,
 * so an edit in flight survives re-renders but not a new value arriving from the replica.
 */
export function useDraft<T>(source: T, sourceKey: string): [T, (draft: T) => void] {
  const [state, setState] = useState({ sourceKey, draft: source });
  if (state.sourceKey !== sourceKey) {
    setState({ sourceKey, draft: source });
  }
  const current = state.sourceKey === sourceKey ? state.draft : source;
  return [current, (draft) => setState({ sourceKey, draft })];
}
